<script>
    import RewardsIcon from "@apps/rewards/components/RewardsIcon.svelte";
    import RewardsPageEmptyStateIcon from "./icons/RewardsPageEmptyStateIcon.svelte";
</script>

<div class="gw-rd-page-widget-empty-state">
    <slot name="content" />
    <div class="gw-rd-page-widget-empty-state__icon">
        <RewardsIcon size="fullWidth">
            <RewardsPageEmptyStateIcon />
        </RewardsIcon>
    </div>
</div>

<style lang="postcss">
    .gw-rd-page-widget-empty-state {
        text-align: center;

        &__icon {
            margin: var(--gw-rd-space-30) auto 0;
            max-width: 140px;
            max-height: 143px;
        }
    }
</style>
